import OpenStratifyButton from '../components/OpenStratifyButton';
import React from "react";
import { Meta } from "../layout/Meta";
import Link from "../components/Link";

export default function CheckoutCancelPage() {
  return (
    <>
      <Meta
        title="Checkout canceled"
        description="Checkout was canceled. Your Stratify plan was not changed."
        path="/checkout/cancel"
        noindex
      />
      <div className="mx-auto w-full max-w-3xl px-5 py-12 md:px-8">
        <h1 id="checkout-cancel-h1" className="text-3xl font-semibold tracking-tight text-ink md:text-4xl">
          Checkout canceled
        </h1>
        <p className="mt-4 text-base leading-relaxed text-muted" role="status">
          Checkout was closed. Return to Stratify to check your current plan.
        </p>
        <OpenStratifyButton />
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/pricing"
            className="inline-flex min-h-11 items-center justify-center rounded-xl bg-ink px-4 text-sm font-semibold text-white"
          >
            Back to pricing
          </Link>
          <Link
            to="/support"
            className="inline-flex min-h-11 items-center justify-center rounded-xl px-4 text-sm font-semibold text-ink/80 ring-1 ring-ink/10"
          >
            Contact
          </Link>
        </div>
      </div>
    </>
  );
}
